<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">
    <ngx-spinner type="ball-beat"></ngx-spinner>
    <div class="container-fluid no-print">
        <span class="brand-text text-primary headText2 mt-2 mb-2">การเบิกน้ำมัน รถตัด/รถคีบ</span>
        <div class="card card-primary card-outline card-tabs">
            <div class="card-header p-0 pt-1 border-bottom-0">
                <ul class="nav nav-tabs headText2" id="payoil-tab" role="tablist">
                    <!-- <li class="pt-2 px-3"><h3 class="card-title headText2">การเบิกน้ำมัน รถตัด/รถคีบ</h3></li> -->
                    <li class="nav-item">
                        <a class="nav-link active" id="oilpay-tab" data-toggle="pill" href="#oilpay" role="tab"
                            aria-controls="oilpay" aria-selected="true">เบิกน้ำมัน</a>
                    </li>
                    <!--
                    <li class="nav-item">
                        <a class="nav-link" id="carkeep-tab" data-toggle="pill" href="#carkeep" role="tab"
                            aria-controls="carkeep" aria-selected="false">...</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="other-tab" data-toggle="pill" href="#other" role="tab"
                            aria-controls="other" aria-selected="false">...</a>
                    </li>
                    -->
                </ul>
            </div>
            <div class="card-body">
                <div class="tab-content" id="payoil-tab-content">
                    <div class="tab-pane fade show active" id="oilpay" role="tabpanel" aria-labelledby="oilpay-tab">
                        <form #frm_payoil="ngForm" (ngSubmit)="save_payoil(frm_payoil.value);" novalidate>
                            <input type="hidden" name="yearid" [(ngModel)]="yearid" required>
                            <input type="hidden" name="usercode" [(ngModel)]="usercode" required>
                            <input type="hidden" name="groupcode" [(ngModel)]="groupcode" required>
                            <div class="row">
                                <div class="col-sm-4">

                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">ประเภท</span>
                                        </div>
                                        <select #oil_type="ngModel" ngModel name="oil_type" class="form-control"
                                            (change)="getdatanext($event)"
                                            [ngClass]="{'is-invalid' : oil_type.invalid && (oil_type.dirty || oil_type.touched)}"
                                            required>
                                            <option value="0" disabled>++เลือก++</option>
                                            <option value="1">รถตัด</option>
                                            <option value="2">รถคีบ</option>
                                        </select>

                                        <div class="invalid-feedback">
                                            <span *ngIf="oil_type.hasError('required')">เลือกประเภท</span>
                                        </div>
                                    </div>
                                    <!--
                                    <ul class="nav nav-pills nav-fill nav-justify-content-center" id="pills-tab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="btn btn-outline-primary" data-bs-toggle="pill" type="button"
                                                (click)="getdatanext('1')" role="tab">รถตัด</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="btn btn-outline-primary" data-bs-toggle="pill" type="button"
                                                (click)="getdatanext('2')" role="tab">รถคีบ</button>
                                        </li>
                                    </ul>-->
                                </div>
                                <div class="col-sm-4">
                                    <div class="input-group mb-3">
                                        <span class="input-group-text">เลือกรหัสรถ <i
                                                class="fas fa-car-side"></i></span>
                                        <input type="text" class="form-control" list="groupdata" #carcode="ngModel"
                                            [disabled]="oil_type.hasError('required')" ngModel name="carcode"
                                            (change)="selectcarcode($event)"
                                            [ngClass]="{'is-invalid' : carcode.invalid && (carcode.dirty || carcode.touched)}"
                                            required>
                                        <datalist id="groupdata">
                                            <option *ngFor="let item of groupdata" [value]="item.carcode">
                                                {{item.regcar}} : {{item.fmname}}
                                            </option>
                                        </datalist>
                                        <div class="invalid-feedback">
                                            <span *ngIf="carcode.hasError('required')">เลือกรหัสรถ</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="input-group mb-3">
                                        <span class="input-group-text">เลือกงวด <i
                                                class="fas fa-calendar-alt"></i></span>
                                        <select #period_cane="ngModel" ngModel name="period_cane" class="form-control"
                                            [disabled]="oil_type.hasError('required')"
                                            [ngClass]="{'is-invalid' : period_cane.invalid && (period_cane.dirty || period_cane.touched)}"
                                            required>
                                            <option value="00">++เลือก++</option>
                                            <!-- <option *ngFor="let item of period_cane" [value]="item.period_cane">
                                                    {{ item.period_cane }}
                                                </option> -->
                                            <option value="00">00</option>
                                            <option value="01">01</option>
                                            <option value="02">02</option>
                                            <option value="03">03</option>
                                            <option value="04">04</option>
                                            <option value="05">05</option>
                                            <option value="06">06</option>
                                            <option value="07">07</option>
                                            <option value="08">08</option>
                                            <option value="09">09</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                        </select>
                                        <div class="invalid-feedback">
                                            <span *ngIf="period_cane.hasError('required')">เลือกงวดตัด</span>
                                        </div>
                                        <span class="input-group-append">
                                            <button (click)="getData(frm_payoil.value)" type="button"
                                                [disabled]="oil_type.hasError('required') || carcode.hasError('required') || period_cane.hasError('required')"
                                                class="btn btn-info btn-flat">ตกลง / Refresh</button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4" style="background-color: lightyellow;">
                                    <div class="mb-3 mt-3">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <label for="payedoil" class="form-label">ตัดอ้อยได้(ตัน)</label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="getOilData.wgt_net" name="wgt_net" readonly>
                                            </div>
                                            <div class="col-sm-6">
                                                <label for="payedoil" class="form-label">เบิกน้ำมันได้(ลิตร)</label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="getOilData.cangetoil" name="cangetoil" readonly>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3 mt-3">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <label for="payedoil" class="form-label">เบิกไปแล้ว(ลิตร):</label>
                                                <input type="number" class="form-control headText2 text-danger"
                                                    [(ngModel)]="getOilData.payed_oil" name="payed_oil" readonly>
                                            </div>
                                            <div class="col-sm-6">
                                                <label for="oil_left" class="form-label">เบิกได้อีก(ลิตร):</label>
                                                <input type="number" class="form-control headText2 text-primary"
                                                    [(ngModel)]="getOilData.oil_left" name="oil_left" readonly>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <label for="oil_left" class="form-label">เบิกได้จริง(ลิตร):</label>
                                                <input type="number" class="form-control headText2 text-danger"
                                                    value="{{oillimit[1]}}" disabled>
                                            </div>
                                            <div class="col-sm-6">
                                                <label for="oil_amount" class="form-label">เบิกครั้งนี้(ลิตร):</label>
                                                <input #oil_amount="ngModel" ngModel type="number"
                                                    class="form-control headText2 text-primary" name="oil_amount"
                                                    id="oil_amount" min=1
                                                    [ngClass]="{'is-invalid' : oil_amount.invalid && (oil_amount.dirty || oil_amount.touched)}"
                                                    required (change)="ckOverpay(frm_payoil.value)">
                                                <div class="invalid-feedback">
                                                    <span
                                                        *ngIf="oil_amount.hasError('required')">ป้อนจำนวนที่ขอเบิก</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <label for="remark" class="form-label">หมายเหตุ</label>
                                                <input #remark="ngModel" ngModel name="remark" type="text" required
                                                    style="text-align: center;" class="form-control"
                                                    placeholder="หมายเหตุ(ถ้ามี)">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3 mt-3">
                                        <button type="submit"
                                            [disabled]="frm_payoil.invalid||oil_amount.invalid||frm_payoil.oil_amount>0||frm_payoil.oil_amount>max_ck"
                                            class="btn btn-primary">
                                            <i class="fas fa-save"> บันทึก </i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-8">
                                    <div class="card card-outline card-primary">
                                        <div class="card-header">
                                            <span class="card-title headText2 text-primary">ข้อมูลการเบิกน้ำมัน | <span
                                                    class="text-danger headText2"> {{ car_code }}
                                                    {{ getOilData.fmname }} กลุ่ม {{ getOilData.groupcode }}
                                                </span></span>
                                            <div class="card-tools">
                                                <button type="button" class="btn btn-tool"
                                                    (click)="getDataoilList(fromdata)"><i
                                                        class="fas fa-sync-alt"></i></button>
                                                <button type="button" class="btn btn-tool"
                                                    data-card-widget="maximize"><i class="fas fa-expand"></i></button>
                                                <button type="button" class="btn btn-tool"
                                                    data-card-widget="collapse"><i class="fas fa-minus"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="card-body table-responsive p-0" style="height: 300px;">
                                            <table class="table table-hover table-head-fixed text-nowrap">
                                                <thead>
                                                    <tr class="text-center headText">
                                                        <th>เลขคำขอ</th>
                                                        <th>วันที่</th>
                                                        <th>งวดตัด</th>
                                                        <th>จำนวนที่เบิก</th>
                                                        <th>ผู้เบิก</th>
                                                        <th>หมายเหตุ</th>
                                                        <th colspan="2">action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of getOilDataList" class="text-center">
                                                        <td>{{ item.docid}}</td>
                                                        <td>{{ item.datepost | date:'medium':'UTC'}}</td>
                                                        <td>{{ item.period_cane }}</td>
                                                        <td>{{ item.oil_amount }}</td>
                                                        <td>{{ item.supname }}</td>
                                                        <td>{{ item.remark }}</td>
                                                        <td>
                                                            <!-- <i class="fas fa-print text-primary" 
                                                            (click)="docSelect(item.dataid);printDoc();"></i> -->
                                                            <a (click)="docSelect(item,1)"
                                                                class="btn btn-outline-primary btn-sm">
                                                                <i class="fas fa-print"> {{ item.cnt_print }} </i>
                                                            </a>
                                                        </td>
                                                        <td>
                                                            <a *ngIf="item.cnt_print==0" (click)="docSelect(item,2)"
                                                                class="btn btn-outline-danger btn-sm">
                                                                <i class="fa fa-close"></i>
                                                            </a>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <!-- {{ frm_payoil.value | json }} -->
                    </div>
                    <div class="tab-pane fade" id="carkeep" role="tabpanel" aria-labelledby="carkeep-tab">
                        ...
                    </div>
                    <div class="tab-pane fade" id="other" role="tabpanel" aria-labelledby="other-tab">
                        ...
                    </div>
                </div>
            </div>
            <!-- /.card -->
        </div>
    </div>
    <div class="container-fluid">
        <div class="card" style="page-break-inside: avoid;">
            <div class="card-body" *ngIf="docSelectData.length">
                <div class="modal-content" *ngFor="let item of docSelectData">
                    <section class="invoice">
                        <div class="row">
                            <div class="col-7">
                                <img src="assets/images/logo-bsf.png">
                                <!-- <h4>
                                <i class="fas fa-globe"></i> AdminLTE, Inc.
                                <small class="float-right">Date: 2/10/2014</small>
                            </h4> -->
                            </div>
                            <!--
                            <div class="col-1 no-print" style="text-align:right;">
                                <button type="button" class="btn btn-outline-primary" (click)="print()">
                                    <i class="fas fa-print"></i>Print</button>
                            </div>
                            -->
                            <div class="col-4" style="text-align:right;" *ngIf="item.cnt_print>0">
                                <span class="headText2 text-danger">ปริ้นซ้ำ ครั้งที่ {{item.cnt_print+1}}</span><br>
                                <span class="headText2 text-danger">หมายเหตุ {{ item.remark_print }}</span>
                            </div>
                        </div>
                        <div class="row invoice-info">
                            <div class="col-sm invoice-col">
                                From
                                <address>
                                    <strong>บริษัท โรงงาน้ำตาลบุรีรัมย์ จำกัด</strong><br>
                                    สำนักงานส่งเสริมการปลูกอ้อยโซน {{ item.supzone }} <br>
                                    ผู้ทำรายการ {{ item.supname }}
                                </address>
                            </div>
                            <div class="col-sm invoice-col">
                                To
                                <address>
                                    <strong>{{ item.fmname }} ,โควตา {{item.fmcode}} </strong><br>
                                    กลุ่ม {{ item.groupcode }} ,รหัสรถที่เบิก {{ item.carcode }}<br>
                                    ทะเบียนรถ {{ item.carReg }}
                                </address>
                            </div>
                            <div class="col-sm invoice-col">
                                <br>
                                <b>ใบเบิกเลขที่ #{{ item.docid }}</b><br>
                                <b>วันที่เบิก </b> {{ item.datepost | date }}<br>
                                <b>งวดที่เบิก :</b> {{ item.period_cane }}
                            </div>
                        </div>

                        <div class="row justify-content-md-center ">
                            <div class="col-md-11">
                                <span class="headText2">รายการขอเบิกน้ำมันครั้งนี้ </span>
                                <table class="table table-bordered">
                                    <thead class="thead-light text-center">
                                        <tr>
                                            <th>วันที่</th>
                                            <th>โซน</th>
                                            <th>งวด</th>
                                            <th>รหัสรถ</th>
                                            <th>ทะเบียนรถ</th>
                                            <th>จำนวน(ลิตร)</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text-center">
                                        <tr *ngFor="let item of docSelectData">
                                            <td>{{ item.datepost | date:'medium':'UTC' }}</td>
                                            <td>{{ item.supzone }}</td>
                                            <td>{{ item.period_cane }}</td>
                                            <td>{{ item.carcode }}</td>
                                            <td>{{ item.carReg }}</td>
                                            <td class="tdUnderline"><b>{{ item.oil_amount }}</b></td>
                                        </tr>

                                    </tbody>
                                </table>
                                <hr>
                                <div class="row">
                                    <div class="col">
                                        <ul class="list-group">
                                            <li
                                                class="list-group-item d-flex justify-content-between align-items-center">
                                                <span class="headText2">รายการงวด {{ item.period_cane }}</span>
                                            </li>
                                            <li
                                                class="list-group-item d-flex justify-content-between align-items-center">
                                                ตัดอ้อยได้(ตัน)
                                                <span class="badge text-bg-light">
                                                    {{ getOilData.wgt_net | number:'1.0-0'}}</span>
                                            </li>
                                            <li
                                                class="list-group-item d-flex justify-content-between align-items-center">
                                                เบิกได้(ลิตร){{ getOilData.wgt_net | number: '1.0-0' }}
                                                x {{ oil_value }}
                                                <span class="badge text-bg-light">
                                                    {{ getOilData.cangetoil | number: '1.0-0'}}</span>
                                            </li>
                                            <li
                                                class="list-group-item d-flex justify-content-between align-items-center">
                                                เบิกไปแล้ว(ลิตร)
                                                <span class="badge text-bg-light">
                                                    {{ getOilData.payed_oil | number:'1.0-0' }}</span>
                                            </li>
                                            <li
                                                class="list-group-item d-flex justify-content-between align-items-center">
                                                คงเหลือเบิกได้(ลิตร)
                                                <span class="badge text-bg-light tdUnderline">
                                                    {{ getOilData.oil_left | number:'1.0-0' }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col">
                                        <ul class="list-group list-group-flush ">
                                            <br>
                                            <li class="list-group-item d-flex justify-content-center">ลงชื่อ
                                                ....................................ผู้ขอเบิก</li>
                                            <br>
                                            <li class="list-group-item d-flex justify-content-center">ลงชื่อ
                                                ....................................ผู้ทำรายการ</li>
                                            <li class="list-group-item d-flex justify-content-center">{{ item.supname }}
                                            </li>
                                            <li class="list-group-item d-flex justify-content-center">{{ item.datepost |
                                                date:'medium':'UTC' }}</li>
                                        </ul>
                                    </div>
                                </div>
                                <!--<br><br>
                                <div class="row justify-content-md-center ">
                                    <div class="col-sm-6 text-center">
                                    </div>
                                    <div class="col-sm-6 text-center">
                                        <div class="row">
                                            <col-auto class="text-right">ลงชื่อ ....................................
                                                ผู้ขอเบิก</col-auto>
                                        </div>
                                        <br><br>
                                        <div class="row">
                                            <col-auto class="text-right">ลงชื่อ ....................................
                                                ผู้ทำรายการ</col-auto>
                                        </div>
                                        <div class="row">
                                            <col-auto class="text-right">{{ item.supname }} </col-auto>
                                        </div>
                                        <div class="row">
                                            <col-auto class="text-right">{{ item.datepost | date:'medium':'UTC' }}
                                            </col-auto>
                                        </div>
                                    </div>
                                </div>
                            -->
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- oilpayPrint พิมพ์ใบเบิกน้ำมัน -->
<!-- 
<div style="visibility: hidden;" id="oilpayPrint">
    {{ docSelectData | json }}
    <div class="row">
        <img src="assets/images/logo-bsf.png">
    </div>
    <div class="row">
        <span class="col-12 text-center" style="font-size: 14px;">ใบเบิกน้ำมัน No.{{ docSelectData.dataid }}</span>
    </div>
    <div class="row">
        <hr>
        <span class="col-12 text-center" style="font-size: 20px;">{{ docSelectData.carcode }} [{{
            docSelectData.groupcode }}]</span>
    </div>
    <div class="row">

    </div>
    <div class="row">
        <span class="col-12 text-center" style="font-size: 20px;">{{ docSelectData.dataid }}</span>
    </div>
    <div class="row">
        <span class="col-12 text-center" style="font-size: 18px;">จอดช่องที่ : {{ docSelectData.dataid }} </span>
    </div>
    <div class="row">
        <span class="col-12 text-center" style="font-size: 14px;">วันที่ทำรายการ : {{ docSelectData.datepost }}
        </span>
        <hr>
    </div>
</div>-->

<app-footer></app-footer>